import { render, staticRenderFns } from "./HJK-13-14-Home.vue?vue&type=template&id=ed7f95fa&"
import script from "./HJK-13-14-Home.vue?vue&type=script&lang=js&"
export * from "./HJK-13-14-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports